<template>
    <div class="googlemap" v-if="id">
        <gmap-map :ref="id" :id="id" :center="center" :zoom="10" :style="mapStyle">
            <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                @click="openInfoWindowTemplate()"
            ></gmap-marker>
            <gmap-info-window
                :options="infoWindow.options"
                :position="infoWindow.position"
                :opened="infoWindow.open"
                @closeclick="infoWindow.open = false"
            >
                <div v-html="info"></div>
            </gmap-info-window>
        </gmap-map>
    </div>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: window.env ? window.env.GOOGLE_MAPS_KEY : '',
        libraries: 'places',
    },
});

export default {
    name: 'MapGoogle',
    props: {
        info: [String, Boolean],
        address: [String, Boolean],
        height: {
            type: String,
            default: '250px',
        },
        width: {
            type: String,
            default: '100%',
        },
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            //markerIcon: '../static/google_marker.png',
            center: { lat: 51.142639, lng: 3.247836 },
            markers: [],
            infoWindow: {
                position: { lat: 51.142639, lng: 3.247836 },
                open: false,
                options: {
                    maxWidth: 300,
                    pixelOffset: {
                        width: 0,
                        height: -35,
                    },
                },
            },
        };
    },
    computed: {
        mapStyle() {
            return `width: ${this.width ? this.width : '100%'}; height: ${this.height ? this.height : '500px'}`;
        },
    },
    methods: {
        openInfoWindowTemplate: function () {
            this.infoWindow.open = true;
        },
        initialize(latitude, longitude) {
            this.markers = [
                {
                    position: { lat: latitude, lng: longitude },
                },
            ];
            this.center = { lat: latitude, lng: longitude };
            this.infoWindow.position = { lat: latitude, lng: longitude };
        },
        convertAddress(add) {
            if (add) {
                var that = this;
                this.$refs[this.id].$mapPromise.then(() => {
                    var geocoder = new google.maps.Geocoder();

                    geocoder.geocode({ address: add }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            var latitude = results[0].geometry.location.lat();
                            var longitude = results[0].geometry.location.lng();
                            that.initialize(latitude, longitude);
                        }
                    });
                });
            }
        },
    },
    watch: {
        address() {
            this.convertAddress(this.address);
        },
    },
    mounted() {
        if (this.address != 'loading') {
            this.convertAddress(this.address);
        }
    },
};
</script>
